import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { BiLinkExternal, BiCog, BiShare } from "react-icons/bi";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../../components/CommonComponents/LeftWrapper";
import RightWrapper from "../../../../components/CommonComponents/RightWrapper";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import MessageSubHeading from "../../../../components/CommonComponents/MessageSubHeading";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import AdminCustomSelect from "../../../../components/CommonComponents/AdminCustomSelect";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import AdminCustomButton from "../../../../components/CommonComponents/AdminCustomButton";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";
import DeviceSelector from "../../../../components/PaymentComponents/DeviceSelector";
import { connect } from "react-redux";
import CashfreeEasySplit from "./CashfreeEasySplit";

const Cashfree = ({ adminSetting }) => {
    const { fetchRequest } = useMyContext();
    const [formData, setFormData] = useState({});
    const [formDataError, setFormDataError] = useState({});
    const [loading, setLoading] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false);

    // Supported devices from backend helper
    const [supportedDevices, setSupportedDevices] = useState(['web', 'Android', 'iOS', 'TV']);

    const combinedRef = useRef({});

    const baseUrl = process.env.REACT_APP_Baseurl;
    const indexApi = `${baseUrl}/admin/cashfree_payment/index`;
    const storeApi = `${baseUrl}/admin/cashfree_payment/store`;

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            setFormData((prev) => ({ ...prev, [name]: checked ? 1 : 0 }));
        }
        if (type === "text") {
            setFormData((prev) => ({ ...prev, [name]: value }));
            setFormDataError((prev) => ({ ...prev, [name]: "" }));
        }
        if (type === "select-one") {
            setFormData((prev) => ({ ...prev, [name]: value }));
            if (value == 1) {
                setFormDataError((prev) => ({ ...prev, test_app_id: "", test_secret_key: "" }));
            }
            if (value == 0) {
                setFormDataError((prev) => ({ ...prev, live_app_id: "", live_secret_key: "" }));
            }
        }
    };

    const handleDeviceChange = (updatedDevices) => {
        // Filter only valid devices and ensure it's an array
        const validDevices = Array.isArray(updatedDevices)
            ? updatedDevices.filter(device => supportedDevices.includes(device))
            : [];
        setFormData((prev) => ({
            ...prev,
            supported_devices: validDevices
        }));
    };

    const formValidation = () => {
        let valid = true;
        setFormDataError({});

        // Validate supported devices
        if (formData?.payment_type !== 1 && (!formData?.supported_devices || !Array.isArray(formData.supported_devices) || formData.supported_devices.length === 0)) {
            toast.warning('Please select at least one supported device.');
            valid = false;
        }

        if (formData?.payment_mode == 0) {
            if (!formData?.test_app_id) {
                setFormDataError((prev) => ({ ...prev, test_app_id: "Test App ID cannot be empty." }));
                combinedRef.current['test_app_id'].focus()
                valid = false;
            }
            if (!formData?.test_secret_key) {
                setFormDataError((prev) => ({ ...prev, test_secret_key: "Test Secret Key cannot be empty." }));
                combinedRef.current['test_secret_key'].focus()
                valid = false;
            }
        }
        if (formData?.payment_mode == 1) {
            if (!formData?.live_app_id) {
                setFormDataError((prev) => ({ ...prev, live_app_id: "Live App ID cannot be empty." }));
                combinedRef.current['live_app_id'].focus()
                valid = false;
            }
            if (!formData?.live_secret_key) {
                setFormDataError((prev) => ({ ...prev, live_secret_key: "Live Secret Key cannot be empty." }));
                combinedRef.current['live_secret_key'].focus()
                valid = false;
            }
        }
        return valid;
    };

    const handleStore = async () => {
        console.log('Cashfree Form data before validation:', formData);
        if (!formValidation()) return;
        setLoading(true);
        const dataToSend = {
            ...formData,
            supported_devices: JSON.stringify(formData.supported_devices || [])
        };
        console.log('Cashfree Data being sent:', dataToSend);
        try {
            const response = await fetchRequest({ method: "POST", url: storeApi, data: dataToSend });
            if (response?.status) {
                toast.success(response?.message);
                setWithOutRefresh((prev) => !prev);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        (async () => {
            setShowOverlay(true);

            // Fetch supported devices from backend
            try {
                const deviceResponse = await fetchRequest({
                    method: 'GET',
                    url: `${process.env.REACT_APP_Baseurl}/admin/supported-devices`,
                    data: {},
                });
                if (deviceResponse?.status && deviceResponse?.data) {
                    setSupportedDevices(deviceResponse.data);
                }
            } catch (error) {
                console.warn('Using default supported devices:', error);
            }

            try {
                const response = await fetchRequest({ method: "GET", url: indexApi, data: {} });
                if (response?.status) {
                    const cashfreeData = response?.cashfree_payment;
                    let deviceArray = []; // default

                    // Parse supported_devices if it exists
                    if (cashfreeData?.supported_devices) {
                        try {
                            const parsedDevices = typeof cashfreeData.supported_devices === 'string'
                                ? JSON.parse(cashfreeData.supported_devices)
                                : cashfreeData.supported_devices;
                            deviceArray = Array.isArray(parsedDevices) ? parsedDevices : [];
                            console.log('Cashfree Loaded devices:', deviceArray);
                        } catch (error) {
                            console.warn('Invalid supported_devices format:', cashfreeData.supported_devices);
                            deviceArray = [];
                        }
                    }

                    setFormData((prev) => ({
                        ...prev,
                        ...cashfreeData,
                        supported_devices: deviceArray
                    }));
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || error?.message);
            } finally {
                setShowOverlay(false);
            }
        })();
    }, [withOutRefresh]);

    // payment type's = [
    //     vendor = 0,
    //     own details = 1
    //     admin = 2,
    // ]

    return (
        <>
            {showOverlay && <Response_Processing />}
            <AdminBackNavigation id="playout-backbtn" path="/payment_settings" text="Back" />
            {adminSetting?.productType === 'full_package' && <AdminSaveHeader heading={"Cashfree Payment"} saveText={"Update Cashfree"} saveMethod={handleStore} loading={loading} />}

            {adminSetting?.productType !== 'full_package' &&
                <LeftWrapper>
                    <Wrapper>
                        <div className="d-flex justify-content-start mb-2 ">
                            <div className="pe-2">
                                <MessageLabel text={"Join with as Vendor"} noMargin />
                            </div>
                            <div className="col-2 ps-2">
                                <AdminSwitch name={"payment_type"} checked={formData?.payment_type == 1} onChange={handleInput} placeHolder />
                            </div>
                            <div className="pe-2">
                                <MessageLabel text={"Use you're Own details"} noMargin />
                            </div>
                        </div>
                    </Wrapper>
                </LeftWrapper>
            }

            {adminSetting?.productType !== 'full_package' && formData?.payment_type === 0 &&
                <CashfreeEasySplit />
            }

            {adminSetting?.productType === 'full_package' || formData?.payment_type === 1 &&
                <FormContainer>
                    <LeftWrapper>
                        <Wrapper>
                            <MessageHeading text="Cashfree Configuration" />
                            <Link to="https://docs.cashfree.com/pg/" target="_blank" className="d-inline-flex  align-items-center gap-2 p-2 rounded-2 shadow mb-4">
                                <MessageSubHeading text="https://docs.cashfree.com/pg/" noMargin />
                                <BiLinkExternal className="text-dark ms-2" />
                            </Link>
                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-6 col-md-6 pe-2">
                                    <MessageLabel text={"Enable Cashfree"} />
                                </div>
                                <div className="col-6 col-md-6 ps-2 text-end">
                                    <AdminSwitch name={"status"} checked={formData?.status == 1} onChange={handleInput} />
                                </div>
                            </div>
                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-7 col-md-7 pe-2">
                                    <MessageLabel text={"Enable Payment Mode"} />
                                </div>
                                <div className="col-3 col-md-3 ps-2 text-end">
                                    <AdminCustomSelect className="payment-mode-custom-select" name="payment_mode" value={formData?.payment_mode} onChange={handleInput} ref={(el) => (combinedRef.current.payment_mode = el)} options={[{ name: "TEST", value: 0 }, { name: "LIVE", value: 1 }]} error={""} defaultOptionName={""} />
                                </div>
                            </div>
                            <MessageLabel text={"Cashfree Label"} />
                            <AdminCustomInput type="text" name="cashfree_label" value={formData?.cashfree_label} onChange={handleInput} placeHolder={"Cashfree label"} ref={(el) => (combinedRef.current.cashfree_label = el)} error={formDataError?.cashfree_label} />
                        </Wrapper>

                        {adminSetting?.productType === 'full_package' &&
                            <Wrapper>
                                <DeviceSelector
                                    selectedDevices={formData?.supported_devices || []}
                                    onDeviceChange={handleDeviceChange}
                                    gatewayName="cashfree"
                                    availableDevices={supportedDevices}
                                    showDescriptions={true}
                                    label="Supported Devices"
                                    showSelectAll={true}
                                    className=""
                                    cardStyle="default"
                                    showDeviceStats={true}
                                />
                            </Wrapper>
                        }

                    </LeftWrapper>
                    <RightWrapper>
                        <Wrapper>
                            <MessageHeading text="Cashfree Key Details (LIVE)" />
                            <MessageLabel text={"Live App ID"} />
                            <AdminCustomInput type="text" name="live_app_id" value={formData?.live_app_id} onChange={handleInput} placeHolder={"CF-xxx-LIVE-APP-ID"} ref={(el) => (combinedRef.current.live_app_id = el)} error={formDataError?.live_app_id} />
                            <MessageLabel text={"Live Secret Key"} />
                            <AdminCustomInput type="text" name="live_secret_key" value={formData?.live_secret_key} onChange={handleInput} placeHolder={"LIVE-SECRET-KEY"} ref={(el) => (combinedRef.current.live_secret_key = el)} error={formDataError?.live_secret_key} />
                        </Wrapper>
                        <Wrapper>
                            <MessageHeading text="Cashfree Key Details (TEST)" />
                            <MessageLabel text={"Test App ID"} />
                            <AdminCustomInput type="text" name="test_app_id" value={formData?.test_app_id} onChange={handleInput} placeHolder={"CF-xxx-TEST-APP-ID"} ref={(el) => (combinedRef.current.test_app_id = el)} error={formDataError?.test_app_id} />
                            <MessageLabel text={"Test Secret Key"} />
                            <AdminCustomInput type="text" name="test_secret_key" value={formData?.test_secret_key} onChange={handleInput} placeHolder={"TEST-SECRET-KEY"} ref={(el) => (combinedRef.current.test_secret_key = el)} error={formDataError?.test_secret_key} />
                        </Wrapper>
                    </RightWrapper>
                    <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={"Update Cashfree"} loading={loading} />
                </FormContainer>
            }
        </>
    );
}

const mapStateToProps = (state) => ({
    adminSetting: state.siteTheme.adminSetting
})

export default connect(mapStateToProps)(Cashfree);

